type ProductCardDataAttrs = {
	"data-product-id"?: string;
	"data-product-listing-result-id"?: string;
	"data-search-result-id"?: string;
};

/**
 * Data attributes to spread onto a product card's root element. DPC's
 * `auto_observe` reads these from the DOM at runtime to attribute impressions
 * and clicks to the originating Depict response (listing or search).
 *
 * Lives in a server-safe module so server components (Storyblok bloks, the
 * SSR'd PLP/SERP grid) can render the attributes directly without crossing
 * into the `"use client"` `dpc` boundary. The actual DPC observer
 * initialization stays in `dpc.ts` (client-only).
 *
 * See https://docs.depict.ai/api-guide/tracking/product-cards
 */
export const getProductCardProps = ({
	productId,
	listingId,
	searchResultId,
}: {
	productId?: string;
	listingId?: string;
	searchResultId?: string;
}): ProductCardDataAttrs => ({
	"data-product-id": productId,
	"data-product-listing-result-id": listingId,
	"data-search-result-id": searchResultId,
});
